import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from '@cbridge-utils/react-redux';
import { Section } from '@cbridge-tools/section';
import { CompactDataGrid } from '@cbridge-tools/default-data-grid';
import { IStream, IStreamServer } from '@cbridge-packages/stream';
import { useConnectedServersColDef } from './colDef/useConnectedServersColDef';
import { streamConnectedServersSectionPropsSelector } from './StreamConnectedServersSection.selector';

const getRowIdFn = (row: IStreamServer) => row.serverId;

export const StreamConnectedServersSection: FunctionComponent<{ streamId: IStream['streamId'] }> = ({ streamId }) => {
  const { t } = useTranslation();

  const columns = useConnectedServersColDef();
  const rows = useSelector(streamConnectedServersSectionPropsSelector, { streamId });

  return (
    <Section title={t('text:configPage.streams.section.connectedServers')}>
      <CompactDataGrid
        getRowId={getRowIdFn}
        rows={rows}
        columns={columns}
        slotProps={{ root: { 'data-testid': 'connected-servers-data-grid' } }}
      />
    </Section>
  );
};
